import React from 'react'
import { FiMenu, FiSearch } from 'react-icons/fi'
import { AuthList } from './auth_list';
import { Notifiable } from './notifiable';
import { Guest } from './guest';

export const MobileMenu = ({avatar, isAuth}) => {
    const [open,setOpen] = React.useState(false);
    return (
        <div className='mobile-menu'>
            {isAuth ? (
                <div className='flex' >
                {true && <div className='search-btn'><FiSearch size={21} /></div>}
                <div onClick={()=>setOpen(!open)} > {avatar ? <img src={avatar} className='avatar' alt="avatar" /> : <img src="/assets/images/faces/default.svg" alt="default" className='avatar' />} </div>
                {true && <div className='icon' onClick={()=>setOpen(!open)} ><FiMenu size={25}/></div>}
            </div>
            ) : (
                <Guest />
            )}

            {open&&(
                <div className='dropdown'>
                    <div className="menu">
                        <ul className="auth">
                          <Notifiable />
                        </ul>
                        <div className="auth-list">
                            <AuthList />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}